// ─── src/hooks/useEcosystemPerception.ts ──────────────────────────────────────

import { useMutation, useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import {
  deleteEcosystemResponse,
  getEcosystemResponses,
  getEcosystemStats,
} from "../api/ecosystemPerception";
import type { EcosystemFilters, EcosystemParams } from "../types/ecosystemPerception";

export const ecosystemKeys = {
  all:   ["ecosystemPerception"] as const,
  list:  (params: EcosystemParams) => [...ecosystemKeys.all, "list", params] as const,
  stats: (filters: EcosystemFilters = {}) => [...ecosystemKeys.all, "stats", filters] as const,
};

export const useEcosystemResponses = (params: EcosystemParams) =>
  useQuery({
    queryKey:        ecosystemKeys.list(params),
    queryFn:         () => getEcosystemResponses(params),
    placeholderData: keepPreviousData,
    staleTime:       30_000,
  });

export const useEcosystemStats = (filters: EcosystemFilters = {}) =>
  useQuery({
    queryKey:        ecosystemKeys.stats(filters),
    queryFn:         () => getEcosystemStats(filters),
    placeholderData: keepPreviousData,
    staleTime:       60_000,
  });

export const useDeleteEcosystemResponse = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteEcosystemResponse(id),
    onSuccess:  () => qc.invalidateQueries({ queryKey: ecosystemKeys.all }),
  });
};
